import Spinner from './Spinner';

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/atoms/Spinner/index.js